import React from 'react';
import { AppBar, createStyles, makeStyles,  Grid, Typography } from '@material-ui/core';
import Toolbar from '@material-ui/core/Toolbar';
import { useTranslation } from 'react-i18next';
import TermsDialog from './Terms/TermsDialog';
import ServiceAboutDialog from './ServiceAboutDialog';
import PublicServiceAboutDialog from '../public/common/PublicServiceAboutDialog';
import Environment from '../../utils/environment';
import ExternalTransmissionDiscipline from './Footer/ExternalTransmissionDiscipline';
import PrivacyPolicy from './Footer/PrivacyPolicy';

interface Props {
  page: string,
  /** 一般開放版の表示であるかを表すフラグ。 */
  isPublic?: boolean,
}

const useStyles = makeStyles(() =>
  createStyles({
    root_search: {
      flexGrow: 1,
      marginTop: '150px',
      bottom: 0,
      width: '100%'
    },
    root_result: {
      flexGrow: 1,
      bottom: 0,
      width: '100%',
    },
    powered_by_text: {
      fontSize: '14px',
      padding: '5px',
    },
    link: {
      fontSize: '14px',
      padding: '5px',
      color: '#ffffff',
      textDecoration: 'underline'
    }
  }),
);

type FooterProps = Props;
const Footer: React.FC<FooterProps> = (props: FooterProps) => {
  /** 環境変数で指定された環境種別を識別するための値。 */
  const stageEnv = process.env['REACT_APP_STAGE_ENV'] || '';
  const classes = useStyles({});
  const setClass = (props.page === 'search')? classes.root_search: classes.root_result;

  const { t } = useTranslation();

  return (
    <div className={setClass}>
      {/** Cypressのチェック用にSCクリックの値をここに出力する */}
      {(stageEnv &&!Environment.isProduction(stageEnv)) &&
        <Typography>
        </Typography>
      }
      <AppBar position="static">
        <Toolbar>
        </Toolbar>
        {/* 「Powered By 駅すぱあと」を表示する。 */}
        <Grid container justify='space-between'>
          <Grid item className={classes.link} >
            <TermsDialog/>
          </Grid>
          {/* プライバシーポリシーについてのリンク。 */}
          <Grid item className={classes.link} >
            <PrivacyPolicy/>
          </Grid>
          {/* 外部通信規律についてのリンク。 */}
          <Grid item className={classes.link}>
            <ExternalTransmissionDiscipline/>
          </Grid>
          <Grid item className={classes.link} >
            { props.isPublic &&
              <PublicServiceAboutDialog />
            }
            { !props.isPublic &&
              <ServiceAboutDialog/>
            }
          </Grid>
          <Grid item>
            <Typography className={classes.powered_by_text}>
              { t('powered_by_ekispert') }
            </Typography>
          </Grid>
        </Grid>
      </AppBar>
    </div>
  )
}

export default Footer;
